import type { ReactNode } from 'react';
import styles from './Section.module.css';

type SectionTheme = 'dark' | 'light';
type SectionShape = 'flat' | 'sheet';

interface SectionProps {
    theme: SectionTheme;
    shape?: SectionShape;
    id?: string;
    labelledBy?: string;
    className?: string;
    children: ReactNode;
}

export default function Section({ theme, shape = 'flat', id, labelledBy, className, children }: SectionProps) {
    return (
        <section
            id={id}
            aria-labelledby={labelledBy}
            data-theme={theme}
            className={[styles.section, styles[shape], className].filter(Boolean).join(' ')}
        >
            {children}
        </section>
    );
}
